import axios from "./axios-handler.service";

const BASE_URL = "/api/MetaVendedor";

export interface MetaVendedorListarDto {
  idMeta: number;
  idUsuario: number;
  nomeUsuario: string;
  mesReferencia: string;
  qtdPontos: number;
  valorBonus: number;
}

export interface AdicionarMetaVendedorCommand {
  idsUsuarios: number[];
  mesReferencia: string;
  qtdPontos: number;
  valorBonus: number;
}

export interface ExcluirMetaVendedorCommand {
  idsMetas: number[];
}

export interface AlterarMetaVendedorCommand {
  idMeta: number;
  qtdPontos: number;
  valorBonus: number;
}

export class MetaVendedorService {
  static async ListarMetas(
    mesReferencia: string,
  ): Promise<MetaVendedorListarDto[]> {
    const response = await axios.get<MetaVendedorListarDto[]>(
      `${BASE_URL}/ListarMetas`,
      {
        params: { mesReferencia },
      },
    );

    return response.data;
  }

  static async AdicionarMeta(
    payload: AdicionarMetaVendedorCommand,
  ): Promise<void> {
    await axios.post(`${BASE_URL}/AdicionarMeta`, payload);
  }

  static async ExcluirMeta(payload: ExcluirMetaVendedorCommand): Promise<void> {
    await axios.post(`${BASE_URL}/ExcluirMeta`, payload);
  }

  static async AlteraMeta(payload: AlterarMetaVendedorCommand): Promise<void> {
    await axios.post(`${BASE_URL}/AlterarMeta`, payload);
  }
}
